import HappyHouseRulesIcon from '@stencil/icons/src/HappyHouseRulesIcon/HappyHouseRulesIcon';
import HappyCheckPointIcon from '@stencil/icons/src/HappyCheckPointIcon/HappyCheckPointIcon';
import HappyRemoveIcon from '@stencil/icons/src/HappyRemoveIcon/HappyRemoveIcon';
import {defaultTheme} from '@stencil/build-theme/src/build-theme';

export function timeFormat(timeString) {
  var hourEnd = timeString.indexOf(':');
  var H = +timeString.substr(0, hourEnd);
  var h = H % 12 || 12;
  var ampm = H < 12 || H === 24 ? 'AM' : 'PM';
  timeString = h + timeString.substr(hourEnd, 3) + ' ' + ampm;
  return timeString;
}

export const getHouseRuleIcon = (response: string) => {
  if (response && response.toLowerCase() === 'yes')
    return (
      <HappyCheckPointIcon
        height="1.5rem"
        width="1.5rem"
        fill={defaultTheme.colors.downriver.dark}
        margin="0 1rem 0 0"
      />
    );
  else if (response && response.toLowerCase() === 'no')
    return (
      <HappyRemoveIcon
        height="1.5rem"
        width="1.5rem"
        fill={defaultTheme.colors.downriver.dark}
        margin="0 1rem 0 0"
      />
    );
  else {
    return (
      <HappyHouseRulesIcon
        height="1.5rem"
        width="1.5rem"
        fill={defaultTheme.colors.downriver.dark}
        margin="0 1rem 0 0"
      />
    );
  }
};
